// Shared admin theme tokens — aligned with the site-wide design-system.css
// palette (pure black / white, no beige/cream in the admin chrome — that's
// reserved for the public "official paper" letterhead treatment only).
// Values here cascade to every Admin*.jsx file that imports them.
export const theme = {
    bg: '#ffffff',
    card: '#ffffff',
    border: '#e5e5e0',
    borderHover: '#0e1013',
    text: '#0e1013',
    textMuted: '#8a8a86',
    textFaint: '#c4c0b4',
    accent: '#0e1013',
    danger: '#a3382f',
};

export const font = "'Helvetica Neue', Arial, sans-serif";

// Helvetica Neue is a system font — nothing to import. Kept as an export
// (now empty) so existing `<style>{fontImport}</style>` call sites keep
// working without edits.
export const fontImport = ``;

export const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    background: theme.card,
    border: `1px solid ${theme.border}`,
    borderRadius: 0,
    color: theme.text,
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: font,
    outline: 'none',
    boxSizing: 'border-box',
};

export const labelStyle = {
    display: 'block',
    fontSize: '11px',
    color: theme.textMuted,
    marginBottom: '6px',
    fontFamily: font,
    fontWeight: 500,
};

export const cardStyle = {
    background: theme.card,
    border: `1px solid ${theme.border}`,
    borderRadius: 0,
    padding: '12px 14px',
};

// Primary action — plain bold clickable text, no pill/background/shadow.
// Pair with className="wlink" (design-system.css) where the file imports
// it, for the animated underline-on-hover affordance.
export const pillButton = {
    padding: '10px 0',
    background: 'none',
    color: theme.text,
    border: 'none',
    borderRadius: 0,
    fontSize: '13px',
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: font,
};

// Secondary action — same treatment, lighter weight/color.
export const outlineButton = {
    padding: '6px 0',
    background: 'none',
    border: 'none',
    color: theme.textMuted,
    borderRadius: 0,
    fontSize: '11.5px',
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: font,
};

export const ghostButton = {
    background: 'none',
    border: 'none',
    color: theme.textMuted,
    fontSize: '12px',
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: font,
};

// Option/selector chip (city picker, timezone picker, position picker,
// filter tabs) — a genuine multi-choice control, not an action button, so
// it keeps a thin square-cornered border to show selected state. No pill
// shape, no shadow.
export const chipButton = {
    padding: '6px 12px',
    background: 'none',
    border: `1px solid ${theme.border}`,
    color: theme.text,
    borderRadius: 0,
    fontSize: '11px',
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: font,
};